import React, { useCallback, useEffect, useState } from 'react'
import { css } from '@emotion/core'
import { func } from 'prop-types'
import { MenuClose } from '@fs/zion-icon'
import { useDSCDispatch } from '../../../state/DSCStore'
import PersonDialogBox from './PersonDialogBox/PersonDialogBox'
import PersonHeader from './PersonDialogBox/PersonHeader/PersonHeader'
import PersonTabs from './PersonDialogBox/PersonTabs/PersonTabs'
import { PersonType } from '../../propTypes/personDataProps'
import { findPerson } from '../../../wcf/global/wcfManagePerson'
import useTreeData from '../../hooks/useTreeData'
import { usePersonViewerDispatch } from './state/PersonViewerStore'

import useLockBodyScrollLock from '../../hooks/useBodyScrollLock'

const cssCloseButton = css`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: 0;
`

export default function PersonViewer({ personData, clearPerson, tree, defaultScroll }) {
  const [isShowing, setIsShowing] = React.useState(false)
  const DSCDispatch = useDSCDispatch()
  const personViewerDispatch = usePersonViewerDispatch()
  const [personTreeData] = useTreeData(personData)

  useEffect(() => {
    if (personTreeData.complete) {
      const isLocked = personTreeData?.res.persons[0]?.personInfo[0]?.readOnly
      personViewerDispatch({
        type: 'SET_LOCK_MEMORIES',
        data: {
          lockMemories: isLocked,
        },
      })
    }
  }, [personTreeData, personViewerDispatch])

  useLockBodyScrollLock(defaultScroll)

  // Prevents relationship line from shrinking when user moves down it
  const [initialPerson, setInitialPerson] = useState(personData)
  const [selectedPerson, setSelectedPerson] = useState(personData)

  useEffect(() => {
    if (personData?.personId !== initialPerson?.personId) {
      setInitialPerson(personData)
      // Reset selected person if personData changes
      setSelectedPerson(personData)
    }
  }, [initialPerson, personData])

  useEffect(() => {
    if (!isShowing) {
      setIsShowing(true)
    }
  }, [DSCDispatch, isShowing])

  const handleClose = () => {
    setIsShowing(false)
    clearPerson()
  }

  const personClickHandler = useCallback(
    (personId) => {
      setSelectedPerson(findPerson(personId, tree))
    },
    [tree]
  )

  return (
    <PersonDialogBox isShowing={isShowing}>
      <div css={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <button css={cssCloseButton} onClick={handleClose} data-dismiss="modal" aria-label="Close" type="button">
          <MenuClose size="sm" color="rgba(255,255,255,0.6)" />
        </button>
        <PersonHeader personData={selectedPerson} />
        <PersonTabs
          personData={selectedPerson}
          tree={tree}
          initialPerson={initialPerson}
          onPersonClick={personClickHandler}
        />
      </div>
    </PersonDialogBox>
  )
}

PersonViewer.propTypes = {
  clearPerson: func,
  personData: PersonType,
}
